export enum Disability {
  No = 0,
  Yes = 1,
  Equal = 2
}
